module.exports = require('./lib/KeyCode.js').default;



//////////////////
// WEBPACK FOOTER
// ./~/keycode-js/index.js
// module id = 3
// module chunks = 0